import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
/**
 * Enum defining the different editor modes where flowchart validation can occur.
 * Each mode may have different validation rules applied.
 */
export enum FlowchartEditorMode {
  /** Editing the template flowchart */
  MAIN_CANVAS = 'MAIN_CANVAS',
  /** Editing single transitions */
  SINGLE_TRANSITION_CANVAS = 'SINGLE_TRANSITION_CANVAS',
  /** At Creation Modification - editing flowchart before it is created */
  ACM_EDITOR = 'ACM_EDITOR',
  /** Post-Creation Modification - editing flowchart after creation */
  PCM_EDITOR = 'PCM_EDITOR',
}

/**
 * Enum defining the different features that can be enabled or disabled for a given editor mode.
 * Note, these are features that we think are applicable regardless of the flowchart type, and therefore
 * are not modeled as platform features.
 */
export enum ProcessFlowchartEditorModeFeatureType {
  ALLOW_START_END_NODE_DELETION = 'ALLOW_START_END_NODE_DELETION',
  SHOW_FLOWCHART_SETTINGS_IF_DEFINED = 'SHOW_FLOWCHART_SETTINGS_IF_DEFINED',
  SHOW_NODE_NAME_INCREMENT = 'SHOW_NODE_NAME_INCREMENT',
  SHOW_NODE_SECTIONS_AND_DATA_FLOW_EDGES = 'SHOW_NODE_SECTIONS_AND_DATA_FLOW_EDGES',
}

const DEFAULT_EDITOR_MODE_FEATURES: Record<ProcessFlowchartEditorModeFeatureType, boolean> = {
  [ProcessFlowchartEditorModeFeatureType.ALLOW_START_END_NODE_DELETION]: false,
  [ProcessFlowchartEditorModeFeatureType.SHOW_FLOWCHART_SETTINGS_IF_DEFINED]: false,
  [ProcessFlowchartEditorModeFeatureType.SHOW_NODE_NAME_INCREMENT]: true,
  [ProcessFlowchartEditorModeFeatureType.SHOW_NODE_SECTIONS_AND_DATA_FLOW_EDGES]: true,
};

export const FEATURE_OVERRIDES_FOR_EDITOR_MODE: Record<
  FlowchartEditorMode,
  Partial<Record<ProcessFlowchartPlatformFeatureType, boolean>> &
    Record<ProcessFlowchartEditorModeFeatureType, boolean>
> = {
  [FlowchartEditorMode.MAIN_CANVAS]: {
    ...DEFAULT_EDITOR_MODE_FEATURES,
    [ProcessFlowchartEditorModeFeatureType.SHOW_FLOWCHART_SETTINGS_IF_DEFINED]: true,
  },
  [FlowchartEditorMode.SINGLE_TRANSITION_CANVAS]: {
    ...DEFAULT_EDITOR_MODE_FEATURES,
    [ProcessFlowchartEditorModeFeatureType.ALLOW_START_END_NODE_DELETION]: true,
    [ProcessFlowchartEditorModeFeatureType.SHOW_FLOWCHART_SETTINGS_IF_DEFINED]: false,
    [ProcessFlowchartEditorModeFeatureType.SHOW_NODE_NAME_INCREMENT]: false,
    [ProcessFlowchartPlatformFeatureType.SHOW_FLOWCHART_TRANSITIONS_SIDEPANEL]: false,
    [ProcessFlowchartPlatformFeatureType.ALLOW_ROUTERS]: false,
    [ProcessFlowchartPlatformFeatureType.ALLOW_STOP_NODES]: false,
    [ProcessFlowchartPlatformFeatureType.ALLOW_LOOPS]: true,
  },
  [FlowchartEditorMode.ACM_EDITOR]: {
    ...DEFAULT_EDITOR_MODE_FEATURES,
    [ProcessFlowchartEditorModeFeatureType.SHOW_NODE_SECTIONS_AND_DATA_FLOW_EDGES]: false,
  },
  [FlowchartEditorMode.PCM_EDITOR]: {
    ...DEFAULT_EDITOR_MODE_FEATURES,
    [ProcessFlowchartEditorModeFeatureType.SHOW_NODE_SECTIONS_AND_DATA_FLOW_EDGES]: false,
  },
};
